// extracted by mini-css-extract-plugin
module.exports = {"containerCheckbox":"styles_containerCheckbox__3gFQG","checkmark":"styles_checkmark__2Q_ju"};